// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__9JeQ4","form":"Contact_form__lcwUN","button":"Contact_button__+a2m3"};